exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Ee7UeomVlUvKuj{box-shadow:0 8px 16px -4px rgba(9,30,66,.25),0 0 0 1px rgba(9,30,66,.08);background:#fff;border-radius:3px;border:1px solid rgba(9,30,66,.08);padding:32px}", ""]);

// exports
exports.locals = {
	"box": "Ee7UeomVlUvKuj"
};